import { importAllImages } from '../../../../utils';

export default process.env.NODE_ENV === 'test'
  ? { image: 'image' }
  : importAllImages(
      require.context(
        './',
        false,
        /\.([pP][nN][gG]|[jJ][pP][eE]?[gG]|[sS][vV][gG]|[bB][mM][pP]|[gG][iI][fF])$/
      )
    );
